import React from 'react'

const CorporateBalances = () => {
  return <div>CorporateBalances</div>
}

export default CorporateBalances
